"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelBrightnessCorrection = exports.CollectionModelBrightnessCorrectionMutator = void 0;
var brightnessCorrection_state_1 = require("./brightnessCorrection.state");
var CollectionModelBrightnessCorrectionMutator = /** @class */ (function () {
    function CollectionModelBrightnessCorrectionMutator(brightnessCorrection) {
        this.brightnessCorrection = brightnessCorrection;
    }
    CollectionModelBrightnessCorrectionMutator.prototype.setValue = function (state) {
        this.brightnessCorrection.collectionState.setFieldValue(this.brightnessCorrection.instanceId, state);
    };
    /** Gives a shallow clone of the brightness correction state */
    CollectionModelBrightnessCorrectionMutator.prototype.getValue = function () {
        return Object.assign({}, this.brightnessCorrection.state);
    };
    /**
     * Remove the state of this brightness correction
     * *Warning:* You will need to unlink & remove the brightness correction from the list before destroying the state.
     * @see CollectionModelBrightnessCorrectionStateMutator.remove
     */
    CollectionModelBrightnessCorrectionMutator.prototype.destroyState = function () {
        this.brightnessCorrection.collectionState.setFieldValue(this.brightnessCorrection.instanceId, null);
    };
    /**
     * Remove the brightness correction,
     * This will unlink and destroy the brightness correction and all associated values.
     *
     * @see CollectionModelBrightnessCorrectionStateMutator.remove
     */
    CollectionModelBrightnessCorrectionMutator.prototype.remove = function () {
        this.brightnessCorrection.brightnessCorrectionState.Mutator.remove(this.brightnessCorrection);
    };
    return CollectionModelBrightnessCorrectionMutator;
}());
exports.CollectionModelBrightnessCorrectionMutator = CollectionModelBrightnessCorrectionMutator;
var CollectionModelBrightnessCorrection = /** @class */ (function () {
    function CollectionModelBrightnessCorrection(state, brightnessCorrectionId, captureId) {
        this.instanceId = brightnessCorrection_state_1.CollectionModelBrightnessCorrectionState.brightnessCorrectionId(captureId, brightnessCorrectionId);
        this.id = brightnessCorrectionId;
        this.captureId = captureId;
        this.brightnessCorrectionState = state;
    }
    Object.defineProperty(CollectionModelBrightnessCorrection.prototype, "state", {
        get: function () {
            return this.collectionState.getFieldValue(this.instanceId);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelBrightnessCorrection.prototype, "collectionState", {
        get: function () {
            return this.brightnessCorrectionState.collection.state;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelBrightnessCorrection.prototype, "isDeletable", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    return CollectionModelBrightnessCorrection;
}());
exports.CollectionModelBrightnessCorrection = CollectionModelBrightnessCorrection;
//# sourceMappingURL=brightnessCorrection.js.map